import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import { toggleAction, playTransitionAction } from 'aurora-composition/actions/auroraUiActions';
import { logout } from 'aurora-composition/modules/authentication/actions/logout';
import dummy from 'aurora-api/dummy/dummyContents';
import MegaMenuLayout from './layouts/AuroraPrimaryMenu';
import styles from './styles';

function Dashboard(props) {
  const { classes, children, history } = props;
  const { sidebarOpen, pageLoaded, locale, isAuthenticated, isGuest } = useSelector(
    createSelector(
      reduxState => reduxState.ui,
      reduxState => reduxState.language,
      reduxState => reduxState.authReducer,
      (ui, language, auth) => {
        return {
          sidebarOpen: ui.sidebarOpen,
          pageLoaded: ui.pageLoaded,
          locale: language.locale,
          isAuthenticated: auth.loggedIn,
          isGuest: auth.guestLoggedIn,
        };
      },
    ),
  );
  const dispatch = useDispatch();

  const profile = () => {
    return {
      avatar: dummy.user.avatar,
      name:
        (locale === 'ar' ? localStorage.getItem('UserNameAr') : localStorage.getItem('UserNameEn')) || dummy.user.name,
    };
  };

  useEffect(() => {
    dispatch(playTransitionAction(true));
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
      setTimeout(() => {
        dispatch(playTransitionAction(true));
      }, 500);
    });

    return () => {
      unlisten();
    };
  }, []);

  const toggleDrawer = () => dispatch(toggleAction());

  const loadTransition = bool => dispatch(playTransitionAction(bool));

  const signOut = () => dispatch(logout());

  return (
    <div
      // style={{ minHeight: appHeight }}
      className={classNames(classes.appFrameInner, classes.topNav)}
    >
      <MegaMenuLayout
        history={history}
        toggleDrawer={toggleDrawer}
        loadTransition={loadTransition}
        sidebarOpen={sidebarOpen}
        pageLoaded={pageLoaded}
        signOut={signOut}
        isLogin={isAuthenticated}
        isGuest={isGuest}
        userAttr={profile()}
      >
        {children}
      </MegaMenuLayout>
    </div>
  );
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  history: PropTypes.object.isRequired,
};

export default withStyles(styles)(Dashboard);
